import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAMqtmbUUYpRTklqZldXBFryjTOEEdBywg",
  authDomain: "goldloan-software.firebaseapp.com",
  projectId: "goldloan-software",
  storageBucket: "goldloan-software.firebasestorage.app",
  messagingSenderId: "1001667673899",
  appId: "1:1001667673899:web:2c0ebe79a06ccb5e098f6e",
  measurementId: "G-5L4YNNHPDG",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

let analytics = null;
if (typeof window !== "undefined") {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    analytics = null;
  }
}

export { app, auth, db, analytics };